import React from "react";
import StablePrime from "../components/Tables/StablePrime";

function Lineperformancecompl({ setPageHeader, urlData }) {
setPageHeader("Line Performance");

  return (
    <div>
      <StablePrime zenTable={true} url="lineperformancecompl" data={urlData || {}} identity="perfparam" />
    </div>
  );
}

export default Lineperformancecompl;
